export const messages = {
  validation: {
    empty: {
      id: 'admin/promotions.form.conditions.marketing-tags.selector.validation.empty',
    },
  },
}
